module.exports = __webpack_public_path__ + "img/Visible-doctor-no.5f887b78.png";